import { connect } from 'react-redux';
import LeftMenuSidebar from './components/LeftMenuSidebar';
import { updateTag } from '../../redux/actions';
import {
  openEditAdvancedFilter,
  openCreateNewAdvancedFilter,
} from '../../redux/actions/filters';
import { setClearRecipe } from '../../redux/actions/ioc';

const mapStateToProps = (state) => {
  return {
    mySubscriptionPlan: state.user.mySubscriptionPlan,
    mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
    leftMenuSideBarCollapsed: state.sidebar.leftMenuSideBarCollapsed,
    advancedFilterMenuOpen: state.sidebar.advancedFilterMenuOpen,
    amberReportCount: state.blog.amberReportCount,
    amberReportCountStatus: state.blog.amberReportCountStatus,
  };
};

const mapDispatchToProps = {
  updateTag,
  openEditAdvancedFilter,
  openCreateNewAdvancedFilter,
  setClearRecipe,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftMenuSidebar);
